import { InjectableClass } from '@fino/lib-injection';
import signatureModal from './modal/signatureModal.html';
import _ from 'lodash';

export class PollingService extends InjectableClass {
  constructor($http, $interval, $uibModal, $uibModalStack) {
    'ngInject';
    super({ $http, $interval, $uibModal, $uibModalStack });
  }

  openModalPolling(scope, onReceivedSignature) {
    // request token and start polling
    this.$http({
      method: 'GET',
      url: scope.serviceUrl + 'token',
    })
      .then((res) => {
        const token = res.data.token;

        scope.vm.token = token;

        this.signatureModalInstance = this.$uibModal.open({
          animation: true,
          scope,
          template: signatureModal,
          windowClass: 'signature-modal',
          bindToController: true,
          controllerAs: 'vm',
          size: 'lg',
        });

        this.requestSignature(token, scope.serviceUrl, onReceivedSignature);

        // simple polling against sign service
        this.singnatureInterval = this.$interval(() => {
          this.requestSignature(token, scope.serviceUrl, onReceivedSignature);
        }, 5000);

        // let socket = this.myWebSocket.getSocket();
        // socket.send({token});
        // socket.onmessage(() => {
        //   this.restoreSignature(response.data.signature);
        //   this.$interval.cancel(this.singnatureInterval);
        //   debugger;
        // });

        // important: stop polling if dialog closes
        this.signatureModalInstance.result.then(
          () => {
            this.$interval.cancel(this.singnatureInterval);
          },
          () => {
            this.$interval.cancel(this.singnatureInterval);
          }
        );
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  closeModal() {
    if (this.signatureModalInstance) {
      this.signatureModalInstance.dismiss();
    }
  }

  requestSignature(token, serviceUrl, onReceivedSignature) {
    this.$http({
      method: 'GET',
      url: `${serviceUrl}signature/${token}`,
      error: {
        silent: true,
      },
    })
      .then((response) => {
        if (response.data.signature) {
          onReceivedSignature(response.data.signature);
          this.signatureModalInstance.dismiss('cancel');
        }
      })
      .catch((error) => {
        // console.info("Wait for signment.");
      });
  }

  sendSms(mobileUrl, data, serviceUrl) {
    data = _.defaults(data, { uri: mobileUrl });

    return this.$http({
      method: 'POST',
      url: `${serviceUrl}sign/sms`,
      data,
      error: {
        silent: true,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-signature-pad/src/signaturePad.polling.service.js